import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78efef86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vnc-password-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { style: {"color":"var(--el-color-danger)"} }, "*", -1))
const _hoisted_3 = { class: "input-row cm-align-center" }
const _hoisted_4 = {
  key: 1,
  class: "cm-ui-txt-cte"
}
const _hoisted_5 = { class: "red-tips" }
const _hoisted_6 = {
  key: 2,
  class: "cm-ui-txt-cte"
}
const _hoisted_7 = { class: "red-tips" }

import { computed, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { User, UserInfo } from '@/services/user'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { VncPdType } from '@/services/login.service'
import BindPhone from '@/views/_components/sms-verify/bind-phone/bind-phone.vue'
import PasswordInit from '@/views/_components/password-init/password-init.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'vnc-password',
  props: {
  modelValue: {
    type: String,
    default: ''
  },
},
  emits: ['update:modelValue', 'keydown'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector()
const userService = injector.get(User)
const userInfo = reactive<Partial<UserInfo>>({})
const bindPhoneVisible = ref(false)
const passwordInitVisible = ref(false)
const passwordForgetVisible = ref(false)

userService.userInfo.subscribe(info => { Object.assign(userInfo, info) })

const headText = computed(() => {
  void locale.value
  if (userInfo.is_account_user) {
    return t('groupClient.remoteAssistVncHeadAccount')
  }
  return t('groupClient.remoteAssistVncHeadVncPwd')
})

const placeholderText = computed(() => {
  void locale.value
  if (userInfo.is_account_user) {
    return t('groupClient.remoteAssistVncPhAccountPwd')
  }
  return t('groupClient.remoteAssistVncPhVncPwd')
})

function handleInput (value) {
  emits('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (userInfo.is_account_user || userInfo.vnc_password === _unref(VncPdType).alreadySet)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h3", null, [
              _createTextVNode(_toDisplayString(headText.value), 1),
              _hoisted_2
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                "model-value": __props.modelValue,
                autocomplete: "new-password",
                size: "medium",
                placeholder: placeholderText.value,
                "show-password": "",
                style: {"flex":"auto"},
                onInput: handleInput,
                onKeydown: _cache[0] || (_cache[0] = _withKeys(() => emits('keydown', __props.modelValue), ["enter"]))
              }, null, 8, ["model-value", "placeholder"])
            ]),
            (!userInfo.is_account_user)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "forget-password",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (passwordForgetVisible.value = true))
                }, _toDisplayString(_unref(t)('groupClient.remoteAssistVncForgotPassword')), 1))
              : _createCommentVNode("", true)
          ], 64))
        : (!userInfo.is_bind_mobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(t)('groupClient.remoteAssistVncBindPhoneTip')), 1),
                _createElementVNode("span", {
                  class: "cm-link-light underline",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (bindPhoneVisible.value = true))
                }, _toDisplayString(_unref(t)('groupClient.remoteAssistVncBindPhoneLink')), 1),
                _createTextVNode(_toDisplayString(_unref(t)('groupClient.remoteAssistVncBindPhoneTipAfter')), 1)
              ]),
              _createVNode(_component_el_button, {
                class: "cm-ui-mt20",
                type: "primary",
                size: "medium",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('groupClient.remoteAssistVncSetPasswordDisabled')), 1)
                ]),
                _: 1
              })
            ]))
          : (userInfo.is_bind_mobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('groupClient.remoteAssistVncSetPwdFirstTip')), 1),
                _createVNode(_component_el_button, {
                  class: "cm-ui-mt20",
                  type: "primary",
                  size: "medium",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (passwordInitVisible.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('groupClient.remoteAssistVncSetPassword')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
    ]),
    _createVNode(BindPhone, {
      modelValue: bindPhoneVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bindPhoneVisible).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(PasswordInit, {
      modelValue: passwordInitVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordInitVisible).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(PasswordInit, {
      modelValue: passwordForgetVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordForgetVisible).value = $event)),
      "is-forget": ""
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})